import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import * as d from "../../reducers/domainReducer";
import MyChartDataTile from "../dashboard/MyChartDataTile";
import SectionLoading from '../common/SectionLoading';
import SectionLoadingError from '../common/SectionLoadingError';
import { getFirstName } from "../../helpers/formatting";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import EVisit_ProxySelector from "./EVisit_ProxySelector";
import * as types from "../../constants/actionTypes";
import FeatureDisabled from "../common/FeatureDisabled";

/**
 * Container component for the E-Visit page.
 */
class EVisit extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.clearZipnosisEvisit();
        logUI("MBHWeb.UI.EVisit.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { hasMyChart, epicEHRDown, location } = this.props;
        const isCovidScreeningModalForProxy = location && location.state && location.state.isCovidScreeningModalForProxy ? true : false;
        const hideProxySelector = location && location.state && location.state.hideProxySelector ? true : false;
        if (hasMyChart && epicEHRDown) {
            return <FeatureDisabled />;
        }
        return <EVisit_ProxySelector isCovidScreeningModalForProxy={isCovidScreeningModalForProxy} hideProxySelector={hideProxySelector} />;
    }
}

const mapStateToProps = (state) => {
    return {
        hasMyChart: state.domain.hm,
        epicEHRDown: state.common.epicEHRDown,
        isActiveFeature_EVisit: state.memberships.isActiveFeature_EVisit,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : ""
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearZipnosisEvisit: () => dispatch({ type: types.ZIPNOSIS_EVISIT_CLEAR })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EVisit);